<template>
<div class="list-info">
  <div class="title"> 이벤트 발생 {{ eventTotalCount }}건</div>
  <div class="list" v-for="eventlevel in eventCountList" :key="eventlevel.eventlevelId">
    <div class="event-indicator icon-dot" :style="{'background-color': eventlevel.eventlevelColorBg}"></div> {{eventlevel.eventlevelCount}}
  </div>
  <ul class="r-list">
    <div class="r-title"> {{ objTotalCount }}개의 가상화 장비</div>
    <div class="r-content" v-for="vmsObj in vmsObjtypeList" :key="vmsObj.objtypeId">
      <li v-if="vmsObj.showFlag">
        <span>{{ vmsObj.name }}</span>
        <span class="high">{{vmsObj.count}}</span>
        <span>{{ vmsObj.countLabel }}</span>
      </li>
    </div>
  </ul>
</div>
</template>

<script>
import virtualMapApi from '@/api/virtual/performance/virtualmap';

export default {
  name: 'WVirtualMapEventInfo',
  props: {
    selectedNode: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      eventTotalCount: 0,
      eventCountList: [],
      objTotalCount: 0,
      vmsObjtypeList: [
        {
          objtypeId: 'VCL',
          name: '호스트 클러스터',
          count: 0,
          countLabel: '대',
          showFlag: false,
        },
        {
          objtypeId: 'VHO',
          name: '호스트',
          count: 0,
          countLabel: '대',
          showFlag: false,
        },
        {
          objtypeId: 'VVM',
          name: 'VM',
          count: 0,
          countLabel: '대',
          showFlag: false,
        },
        {
          objtypeId: 'VDSC',
          name: '스토리지 클러스터',
          count: 0,
          countLabel: '대',
          showFlag: false,
        },
        {
          objtypeId: 'VDS',
          name: '스토리지',
          count: 0,
          countLabel: '대',
          showFlag: false,
        },
      ],
    };
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.active) {
          this.vmsObjtypeList.forEach((objtype) => {
            objtype.showFlag = false;
          });
          this.loadData();
        }
      },
      immediate: true,
    },
    active: {
      handler(active) {
        if (active) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    loadData() {
      const selectedNode = this.selectedNode;
      virtualMapApi.getVirtualMapObjEventInfo({
        objId: selectedNode.obj ? selectedNode.obj.objId : null,
        virtualcenterGroupId: selectedNode.virtualcenterGroupId,
        objtypeId: selectedNode.obj ? selectedNode.obj.objtypeId : selectedNode.objtypeId,
      }).then((response) => {
        if (response.data.success) {
          const objCountMap = response.data.data.objCount;
          const eventCountList = response.data.data.eventCount;

          let eventTotal = 0;
          eventCountList.forEach((event) => {
            eventTotal += event.eventlevelCount;
          });
          this.eventTotalCount = eventTotal;
          this.eventCountList = eventCountList;

          const selectedObjtype = selectedNode.obj ? selectedNode.obj.objtypeId : selectedNode.objtypeId;
          const isSelectedNodeObj = selectedObjtype === 'VCL' || selectedObjtype === 'VHO' || selectedObjtype === 'VDSC' || selectedObjtype === 'VDS';
          const keys = Object.keys(objCountMap);
          this.vmsObjtypeList.forEach((objtype) => {
            const isExist = keys.find((ot) => ot === objtype.objtypeId);
            if (isExist) {
              objtype.count = objCountMap[objtype.objtypeId];
              objtype.showFlag = true;
            }
            if (isSelectedNodeObj && objtype.objtypeId === selectedObjtype) {
              objCountMap.totalCount += 1;
              objtype.count = 1;
              objtype.showFlag = true;
            }
          });

          this.objTotalCount = objCountMap.totalCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 천단위 구분
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$url : '../../../../assets/img/';

.list-info{
  display: inline-block;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border: 1px solid #555; //$gray
  background-color: #6b6a72;
  padding: 15px 18px;
  color: #fff;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  .title, .r-title {
    margin-left: 6px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    // letter-spacing: -0.5px
  }
  .title {
  float: left;
  margin-right: 22px;
  }

  .list{
    display: flex;
    float: left;
    margin-right: 10px;
    margin-top: 3px;

    .event-indicator {
      height: 9px;
      width: 9px;
      border-radius: 50%;
      margin-right: 6px;
      margin-top: 2px;
    }
  }

  .r-list{
    display: flex;
    float: right;
    color: #eeedf2;
    align-items: center;
    margin-top: -2px;

    .r-content > li{
      margin: 0 0 0 12px;
      padding: 0 0 0 8px;
      font-weight: 400;
      font-size: 12px;
      background: url($url + 'dot_l.png') no-repeat 0 8px;
      height: 23px;
    }
    & > li > .num {
      display: inline-block;
      width: 19px;
      height: 19px;
      border-radius: 4px;
      background-color: #38383a;
      color: #fff;
      font-size: 12px;
      line-height: 21px;
      text-align: center;
      margin-right: 6px;
      float: left;
      // font-family:  'Open Sans', sans-serif;
    }
    .high{
      color: #9ad0f4;
      // font-family:  'Open Sans', sans-serif;
      font-weight: 500;
      margin: 0 1px 0 3px;
    }
  }
}

@media only screen and (max-width: 1630px){
.list-info{
  height: 40px;
    .r-list{
    //  margin-top: 3px;
      margin-left: -6px;
    }
    .r-title {
      font-size: 13px;
    }
  }
}
@media only screen and (max-width: 1460px){
  .list-info{
    height: 62px;
      .r-list{
        margin-top: 0;
        margin-left: -3px;
        float: left;
        .r-content > li{
          margin: 0 0 1px 8px;
          padding: 0 0 0 8px;
        }
      }
      .r-title {
        font-size: 13px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapEventInfo.vue